<template>
  <div class="accounting-container">
    <!-- 假期新增 -->
    <avue-form
      ref="basicInfo"
      v-if="checkType == 1"
      v-model="formData"
      :option="formOption"
    >
      <template slot="effectDate">
        <el-date-picker
          v-model="effectDate"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template> 
    </avue-form>

    <!-- 假期减少 -->
    <div v-else class="holiday-reduce">
      <template v-for="(item, index) in reduceList">
        <div class="type-container" :key="index">
          <div class="reduce-one" >
            <div class="reduce-label"><span v-if="index == 0" class="red-icon">* &nbsp;</span>假期类型:</div>
            <div class="reduce-content">
                <el-select
                  size="small"
                  v-model="reduceList[index]['vacationType']"
                  placeholder="请选择类型"
                >
                  <el-option
                    v-for="item in eventTypeAarray"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                    <span style="float: left">{{item.dictValue}}</span>
                    <span style="float: right;color: #FF9900">{{item.showLabel}}</span>
                  </el-option>
                </el-select>
            </div>

            <div class="icon-add" @click="addType" v-if="index == 0">
              <i class="el-icon-circle-plus-outline"></i>
              <span class="add-text">添加</span>
            </div>
          </div>

          <div class="reduce-one">
            <div class="reduce-label"><span v-if="index == 0" class="red-icon">* &nbsp;</span>天数:</div>
            <div class="reduce-content">
              <el-input size="small" v-model="reduceList[index]['days']" placeholder="请输入天数" >
                <template slot="append">天</template>
              </el-input>
            </div>

            <div class="reduce-tip" v-if="item['vacationType'] == 2 || item['vacationType'] == 4 || item['vacationType'] == 5 || item['vacationType'] == 12">
              <i class="el-icon-warning"></i>
              {{item['vacationType'] == 2?'育儿假':item['vacationType'] == 4?'调休':item['vacationType'] == 12?'结余假':'年休假'}}
              最大可用天数为
              {{item['vacationType'] == 2?
                Number(holidayDetail['usableChildVacation']).toFixed(2):item['vacationType'] == 4?
                Number(holidayDetail['usableIncreatedVacation']).toFixed(2):item['vacationType'] == 12?
                Number(holidayDetail['usableBalanceVacation']).toFixed(2):Number(holidayDetail['usableYearVacation']).toFixed(2)}}天
            </div>
          </div>
        </div>
      </template>
      <div class="reduce-one" >
        <div class="reduce-label">备注:</div>
        <div class="reduce-content">
          <el-input size="small" v-model="reduceForm['checkRemark']" placeholder="请输入备注" />
        </div>
      </div>

      <div class="reduce-one" >
        <div class="reduce-label">附件:</div>
        <div class="reduce-content">
          <WordUpload
            @showFileName="showFileNames"
            fileMenuName="假期核算"
            limit="1"
            :plain="true"
            :id="eventId"
          />
          <div class="">
            <template v-for="(item, index) in files">
              <div class="file_wrapper" :key="index">
                <a
                  class="file_button"
                  target="_blank"
                  :href="
                    isWord(item.fileUrl)
                      ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                        item.fileUrl
                      : item.fileUrl"
                  type="text"
                  size="small"
                >
                  {{ item.fileName }}
                </a>
                <i
                  @click="downLoadFile(item.id)"
                  class="el-icon-download del_icon"
                ></i>
                <i
                  @click="delFile(item.id, index, 'file')"
                  class="el-icon-circle-close del_icon"
                ></i>
              </div>
            </template>
          </div>
        </div>
      </div>      
    </div>

    <div class="button-container">
      <el-button type="primary" @click="saveDataOne" v-if="checkType == 1">保存</el-button>
      <el-button type="primary" @click="saveDataTwo" v-else>保存</el-button>
    </div>
  </div>
</template>
<script>
import { holidayTypeDict, holidayInfoDetail, getHolidayEventCheck, addHolidayEvent } from "@/api/hr/holiday"
import { downLoadTemplate } from "@/router/downLoadTem"
import * as dictionaries from "@/api/zd/dictionaries"
import WordUpload from "@/components/wordUpload/wordUpload"
export default {
  name: 'AccountingForm',
  data() {
    return {
      files: [],
      holidayDetail: {},
      eventTypeAarray: [],
      reduceList: [{days: '',vacationType: ''}],
      reduceForm: {
        checkRemark: ''
      },
      effectDate: [],
      formData: {},
      formOption: {
        gutter: 20,
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '核算天数',
          prop: 'accountingNum',
          append:'天',
          span: 24,
          rules: [
            {
              required: true,
              message: '请输入核算天数',
              trigger: 'blur'
            }
          ]
        },{
          label: "有效期",
          span: 24,
          formslot: true,
          prop: "effectDate",
          format:'yyyy-MM-dd',
          valueFormat:'yyyy-MM-dd'
        },{
          label: '备注',
          span: 24,
          prop: 'remarks'
       }]
      }
    }
  },
  props: {
    // 显示类型
    checkType: {
      type: String,
      default: '2'
    },
    // 用户ID
    userId: {
      type: String,
      required: true
    },
    // 事件ID
    eventId: {
      type: String,
      required: true
    },
    // 查询年份
    filterYear: {
      type: String,
      default: ''
    },
    // 核算年份
    annual: {
      type: String,
      default: ''
    }
  },
  components: {
    WordUpload 
  },
  watch: {
    userId: {
      handler(newId, oldId) {
        if(this.checkType == 2){
          this.getStaticData()
        }
      }
    },
    filterYear: {
      handler(newId, oldId){
        if(this.checkType == 2){
          this.getStaticData()
        }
      }
    }
  },
  mounted() {
    // this.getHolidayDic()
    if(this.checkType == 2){
      this.getStaticData()
    }else {
      this.getHolidayDic()
    }
  },
  methods: {
    saveDataOne() {
      if(this.effectDate !== []) this.formData['effectDate'] = this.effectDate
      // this.$emit('saveOpration', this.formData)
      let self = this
      let params = {
        validBeginTime: this.formData['effectDate'][0],
        validEndTime: this.formData['effectDate'][1],
        checkDay: Math.abs(Number(this.formData['accountingNum'])),
        checkRemark: this.formData['chekcRemark'],
        checkStatus: 1,
        annual: this.annual,
        id: this.eventId
      }
      addHolidayEvent(params).then(res => {
        if(res['data']['code'] == 200){
          self.effectDate = []
          self.$emit('closeDialog')
          self.$message({
            type: "success",
            message: "核算成功",
          })
        }else{
          self.$message({
            type: "warning",
            message: "核算失败",
          })
        }
      })      
    },

    saveDataTwo() {
      let self = this
      // this.$emit('saveOprationReduce', this.reduceForm)
      // 校验数据
      if(this.reduceList[0]['days'] == '' || this.reduceList[0]['vacationType'] == '') {
        this.$message({
          type: "warning",
          message: "请补全数据后核算",
        })
        return false
      }
      // 核算
      this.reduceList.map((item, index) => {
        item['days'] = Math.abs(Number(item['days']))
      })
      this.reduceForm.checkDetails = this.reduceList
      this.reduceForm.id = this.eventId
      getHolidayEventCheck(this.reduceForm).then(res => {
        console.info(res, 'holidayCheck')
        if(res['data']['code'] == 200){
          self.$emit('closeDialog')
          self.$message({
            type: "success",
            message: "核算成功",
          })          
        }else{
          self.$message({
            type: "warning",
            message: "核算失败",
          })
        }
      })
    },

    addType() {
      this.reduceList.push({
        days: '',
        vacationType: ''
      })
    },

    getStaticData() {
      let self = this
      let initYear = new Date()
      let params = {
        userId: this.userId,
        annual: !this.filterYear || this.filterYear == ''? initYear.getFullYear(): this.filterYear,
        vacationTypes: []
      }
      holidayInfoDetail(params).then(res => {
        if(res['data']['code'] == 200){
          self.holidayDetail = res['data']['data']
          self.$set(self.$data,'holidayDetail', res['data']['data'])
          self.$nextTick(() => {
            self.holidayDetail = res['data']['data']
            self.getHolidayDic()
          })
        }
        // console.info(res, 'holidayInfoDetail')
      })
    },

    getHolidayDic() {
      let self = this
      holidayTypeDict().then(res => {
        if(res['data']['code'] == '200'){
          self.eventTypeAarray = res['data']['data']
          if(self.checkType == 2){
            self.eventTypeAarray.map(item => {
              switch(item.dictKey) {
                case '2':
                    item.showLabel = `余：${Number(self.holidayDetail['usableChildVacation']).toFixed(2)}天`
                  break;
                case '4':
                    item.showLabel = `余：${Number(self.holidayDetail['usableIncreatedVacation']).toFixed(2)}天`
                  break;
                case '5':
                    item.showLabel = `余：${Number(self.holidayDetail['usableYearVacation']).toFixed(2)}天`
                  break;
                case '12':
                    item.showLabel = `余：${Number(self.holidayDetail['usableBalanceVacation']).toFixed(2)}天`
                  break;
                default:
                    item.showLabel = ``
                  break;
              }
            })
          }

        }
      })
    },

    resetForm() {
      if(this.$refs['basicInfo']) this.$refs['basicInfo'].resetForm()
      this.reduceList = [{days: '',vacationType: ''}],
      this.reduceForm = {
        checkRemark: ''
      }
    },

    showFileNames(data) {
      this.files = data
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

       //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.files.splice(index, 1)
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },    

  }
}
</script>
<style lang="scss" scoped>
.button-container{
  text-align: center;
  .el-button{
    width: 150px;
  }
}
.reduce-one {
  display: flex;
  justify-content: left;
  margin-bottom: 30px;
  align-items: center;
  position: relative;
  .reduce-label {
      width: 90px;
      text-align: right;
      margin-right: 12px;
      .red-icon{ color: #FF3B30; }
  }
  .reduce-content{
    flex: 1;
  }
  .icon-add{
    position: absolute;
    top: 7px;
    right: -55px;
    display: flex;
    align-items: center;
    cursor: pointer;
    span{
      font-weight: 400;
      font-size: 13px;
      color: #999;
    }
    i{
      color: #999;
      margin-right: 3px;
      font-size: 14px;
    }
  }
  .reduce-tip{
    position: absolute;
    left: 102px;
    bottom: -20px;
    color: #FF9900;
    font-size: 13px;
    i{
      color: #ff9900;
      font-size: 13px;
    }
  }
  a.file_button {
    font-size: 13px;
    color: #666;
    margin-top: 10px;
    margin-right: 25px;    
  }
  .del_icon {
    margin-top: 10px;
    margin-left: 5px;
    cursor: pointer;
  }

}
/deep/ .el-select{
  width: 100%;
}
</style>